
export const menudb = [
    {
      sopas: [
        {
          name: "Ramen clásico",
          image: "ramenClasico",
          description: "Sopa de fideos con base de cerdo con trozos de pollo, cerdo, algas y otras verduras.",
          price: 15,

        },
        {
            name: "Ramen Picante",
            image: "ramenPicante",
            description: "Sopa de fideos ramen con caldo picante coreano, acompañado de pollo y cerdo.",
            price: 17,

          },
          {
            name: "Ramen Chesse",
            image: "ramenChesse",
            description: "Sopa de fideos ramen y caldo a base de soyu acompañado de pollo y cerdo bañado en mozzarela y topping.",
            price: 20,

          },
          {
            name: "Marisco Ramen",
            image: "ramenMarisco",
            description: "Sopa de fideos ramen y caldo a base de mariscos (langostinos) acompañados de algas y otras verduras.",
            price: 20,

          }
          ,
          {
            name: "Tonkotsu ramen",
            image: "ramenTonkotsu",
            description: "Sopa de fideos ramen y caldo a base de cerdo, acompañado de chashu (carne de cerdo), algas y otras verduras.",
            price: 25,

          }
          ,
          {
            name: "Miso Ramen",
            image: "ramenMiso",
            description: "Sopa de fideos ramen y caldo a base de miso, acompañados de chashu (carne de cerdo), algas y otras verduras.",
            price: 25,

          }
      ],
      cornDogs: [
        {
            name: "CLÁSICO",
            image: "clasico",
            description: "Masa hot dog con queso mozzarella",
            price: 10,

          },
          {
            name: "RAMEN",
            image: "ramen",
            description: "Masa de fideos ramen con hot dog y queso mozzarella",
            price: 10,

          },
          {
            name: "PAPAS",
            image: "papas",
            description: "Masa de papas con hot dog y queso mozzarella",
            price: 11,
          },
          {
            name: "CHEETOS",
            image: "cheetos",
            description: "Masa de cheetos con hot dog y queso mozzarella",
            price: 10,
          },
          {
            name: "AMERICANO",
            image: "americano",
            description: "Masa en salsa americana con hot dog y queso mozzarella",
            price: 10,
          },
          {
            name: "CRUJIENTE",
            image: "crujiente",
            description: "Masa de cereales con hot dog y queso mozzarella",
            price: 11,
          },
          {
            name: "SALSA DULCE",
            image: "salsaDulce",
            description: "Masa en salsa de maracuya con hot dog y queso",
            price: 10,
          },
          {
            name: "FULL MOZZARELLA",
            image: "fullMozarella",
            description: "Masa con queso mozzarella",
            price: 15,
          },
          {
            name: "BULDAK",
            image: "buldak",
            description: "Masa con salsa de 3 fuegos y hot dog",
            price: 11,
          },
          {
            name: "KOREAN POLLO",
            image: "koreanPollo",
            description: "Masa con pollo y queso mozzarella",
            price: 15,
          },
          {
            name: "KOREAN PIG/CERDO",
            image: "koreanPig",
            description: "Masa con cerdo y queso mozzarella",
            price: 15,
          }
      ],
      obentos: [
        {
            name: "CHICKEN TERIYAKI BOX",
            image: "chickenTeriyakiBox",
            description: "Filete de pollo a la plancha glaceada con salsa teriyaki acompañado de arroz blanco, 2 piezas de Gzoya, 3 piezas de Maki y ensalada de pasas al estilo japonés",
            price: 32,
          },
          {
            name: "CHICKEN KATSU BOX",
            image: "chickenKatsuBox",
            description: "Filete de pollo empanizado y bañado den salsa katsu acompañado con arroz blanco, 2 piezas de Gzoya, 3 piezas de Maki y ensalada de pasas al estilo japonés.",
            price: 32,
          },
          {
            name: "TERIYAKI O KATSU BOX",
            image: "obentoTeriyaki",
            description: "Filete de pollo a la plancha glaceada con salsa teriyaki, acompañado de arroz blanco, 3 piezas de Gzoya, 3 piezas de kimbap, más tteokbokki y ensalada.",
            price: 32,
          },
          {
            name: "TERIYAKI O KATSU BOX",
            image: "obentoTeriyaki2",
            description: "Filete de pollo a la plancha glaceada con salsa teriyaki, acompañado de arroz blanco, 3 piezas de Gzoya, 3 piezas de kimbap, más tteokbokki, ensalada y buldak carbonada.",
            price: 39,
          }
      ],
      bebidas: [
        
      ],
      extras: [
        {
            name: "POLLO KOREANO",
            image: "polloKoreano",
            price: 15
          },
          {
            name: "BOMBAS DE QUESO",
            image: "bombasDeQueso",
            price: 9,
          },
          {
            name: "ONIGIRI",
            image: "onigiri",
            price: 7,
          }
      ]
    }
  ];
